"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoModelNoPartyId = exports.UserInfoModel = void 0;
const helpers_1 = require("@tpd-web-common-libs/nodejs-library/dist/src/helpers");
class UserInfoModel {
    constructor(_data) {
        this._data = _data;
        try {
            const utente = (typeof this._data == "string" && JSON.parse(this._data)) || this._data;
            this.username = utente.username;
            this.partyId = utente.partyId;
            this.registry = utente.registry;
            this.customer = utente.customer;
            this.policies = utente.policies;
            this.allTelematicContracts = utente.allTelematicContracts;
        }
        catch (e) {
            helpers_1.ConsoleHelper.error("Errore durante la creazione della UserInfoModel", e);
        }
    }
}
exports.UserInfoModel = UserInfoModel;
class UserInfoModelNoPartyId {
    constructor(_data) {
        this._data = _data;
        try {
            const utente = (typeof this._data == "string" && JSON.parse(this._data)) || this._data;
            this.username = utente.username;
            this.registry = utente.registry;
            this.customer = utente.customer;
            this.policies = utente.policies;
            this.allTelematicContracts = utente.allTelematicContracts;
        }
        catch (e) {
            helpers_1.ConsoleHelper.error("Errore durante la creazione della UserInfoModel", e);
        }
    }
}
exports.UserInfoModelNoPartyId = UserInfoModelNoPartyId;
